export const defaultOptions = {
    rotate: 0,
};
